module.exports = __webpack_public_path__ + "static/media/logo.7cbfa4b5.svg";